import { useQuery } from '@tanstack/react-query';
import { useSnackbar, SnackbarStatus } from '@weareopenr/component-library';
import { getAddons } from 'src/api/getAddons/getAddons';
import { useUserTracking } from '../useUserTracking/useUserTracking';
import { QueryKeys } from 'src/constants/QueryKeys';

export const useGetAddons = () => {
  const { showSnackbar } = useSnackbar();
  const { captureException } = useUserTracking();
  return useQuery({
    queryKey: [QueryKeys.ADDONS],
    queryFn: getAddons,
    onError: (e: Error) => {
      showSnackbar({
        message: e.message,
        status: SnackbarStatus.ERROR,
      });
      captureException(e);
    },
  });
};
